<template>
    <div id="main">
        <div class="barcode_top top_barcode"></div>
        <div class="barcode_title" v-if="action==='collectingPointStoreExpress' && flow === 'WITHOUT_LABEL' && step=='1'">{{$t('enterBarCode.EnterBarcodeWITHOUT_LABEL')}}</div>
        <div class="barcode_title" v-else-if="action==='collectingPointStoreExpress' && flow === 'WITHOUT_LABEL' && step=='2'">{{$t('enterBarCode.EnterBarcodeStore')}}</div>
        <div class="barcode_title" v-else>{{$t('enterBarCode.EnterBarcode')}}</div>
        <div class="barcode_input">
            <input autofocus="autofocus" v-model="expressNumber" type="text" class="code_input">
            <div class="close" @click="cleanInput"><span></span></div>
        </div>
        <div class="barcode_msg">
            <!-- <div class="first">(If barcode not correct)</div>
            <div>(If order is not belongs to to pickup point)</div>
            <div>(If order is not belongs to the selected logistics company)</div> -->
        </div>
        <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
        <button class="details_bt_b" @click="tiaoZhuan()">{{$t('common.Confirm')}}</button>
        <div class="curtain" v-if="showCurtain"></div>
        <div class="popup-msg" v-if="showCurtain">
            <div class="popup-msg-text">The order of this PIN code is not belongs to this pickup point. It should be at
                {location name}
            </div>
            <button class="try-again">Try again</button>
        </div>
        <transition name="tipMsg">
            <div class="tip-msg" v-if="showTip">
                {{tipMsg}}
            </div>
        </transition>
        <transition name="successTipMsg">
          <div class="tip-msg-success" v-if="showSuccessTip">
            {{ successTipMsg }}
          </div>
        </transition>
    </div>
</template>

<script>
export default {
  name: 'EnterBarcode',
  data () {
    return {
      action: null,
      pin: null,
      expressNumber: null,
      showCurtain: false,
      showTip: false,
      tipMsg: null,
      isNeedScanOtherNumber: false,
      oldScanResult: '',
      otherNumber: '',
      flow: '',
      step: 1,
      showSuccessTip: false,
      successTipMsg: null
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  mounted () {
    this.flow = this.$route.query.flow
    this.step = this.$route.query.step
    if (this.$route.query.isNeedScanOtherNumber) {
      this.isNeedScanOtherNumber = this.$route.query.isNeedScanOtherNumber
      this.oldScanResult = this.$route.query.oldScanResult
      this.otherNumber = this.$route.query.otherNumber
    }
    this.action = this.$route.query.action
    this.pin = this.$route.query.pin
    this.queryNumber = this.$route.query.expressNumber
    // 解决手机端无法自动聚焦
    $('input[autofocus="autofocus"]').focus()
  },
  methods: {
    cleanInput () {
      this.expressNumber = null
    },
    tiaoZhuan () {
      const vue = this
      let next = this.$route.query.next
      switch (this.action) {
        // 查询包裹
        case 'parcelInfo':
          // 先查询是否存在
          this.axios({
            method: 'get',
            url: this.api.parcel + vue.expressNumber
          }).then(function (response) {
            let ordersId = response.data.ordersId
            vue.$router.push('/order/details?order=' + ordersId + '&logisticsId=' + response.data.deliverMerchantId)
          }).catch(function (error) {
            // vue.displayTip('expressNumber Not Found')
            vue.displayTip(error.data && error.data.message ? error.data.message : 'error')
          })
          break
          // 自提点签入 - 存件/退件
        case 'collectingPointStoreExpress':
          // vue.$router.push('/return/success?msg=StoreSuccess&action=' + vue.action + '&orderId=f23ce9e0-1aec-43f3-9851-e46c9ee04637')
          // return false
          // 请求
          let data
          let returnMessage = `${this.$t('labeledPackage.returnSuccess')}`
          // if (vue.isNeedScanOtherNumber) {
          //   if (vue.expressNumber.length !== 32) {
          //     vue.displayTip(this.$t('barCode.formatnomatch'))
          //     return
          //   }
          //   data = {
          //     expressNumber: vue.otherNumber,
          //     newLabelNumber: vue.expressNumber,
          //     additionalTrackingNumber: vue.oldScanResult
          //   }
          // } else {
          //   data = {
          //     expressNumber: vue.expressNumber
          //   }
          // }
          if (vue.flow === 'WITH_LABEL') {
            data = {
              flow: 'WITH_LABEL',
              expressNumber: vue.expressNumber
            }
          } else if (vue.flow === 'WITHOUT_LABEL') {
            if (vue.step == '1') {
              data = {
                flow: 'WITHOUT_LABEL',
                expressNumber: vue.expressNumber
              }
            } else if (vue.step == '2') {
              if (vue.expressNumber.length > 255 || vue.expressNumber.length < 10) {
                vue.displayTip(this.$t('barCode.formatnomatch'))
                return
              }
              data = {
                flow: 'WITHOUT_LABEL',
                expressNumber: vue.otherNumber,
                newLabelNumber: vue.expressNumber,
                additionalTrackingNumber: vue.oldScanResult
              }
            }
          }
          // console.log('data', data)
          // return
          vue.axios({
            method: 'post',
            url: this.api.collectingPointStoreExpress,
            data
          }).then(function (response) {
            // if (response.data.isNeedScanOtherNumber) {
            console.log('response', response, vue.flow, vue.step)
            if (vue.flow === 'WITHOUT_LABEL' && vue.step == '1') {
              // vue.$router.push({
              //   name: 'Barcode',
              //   query: {
              //     action: vue.action,
              //     next: vue.$route.query.next,
              //     otherNumber: response.data.expressNumber,
              //     oldScanResult: vue.expressNumber,
              //     isNeedScanOtherNumber: response.data.isNeedScanOtherNumber
              //   }
              // })
              vue.$router.push({
                name: 'Step1SuccessWithoutLabel',
                query: {
                  flow: vue.flow,
                  step: vue.step,
                  action: vue.action,
                  next: vue.$route.query.next,
                  otherNumber: response.data.expressNumber,
                  oldScanResult: vue.expressNumber,
                  isNeedScanOtherNumber: response.data.isNeedScanOtherNumber
                }
              })
            } else if (vue.flow === 'WITHOUT_LABEL' && vue.step == '2') {
              let orderId = response.data.ordersId
              let message = 'CustomerStoreSuccess'
              vue.$router.push('/return/success?msg=' + message + '&action=' + vue.action + '&orderId=' + orderId + '&expressNumber=' + response.data.expressNumber + '&next=' + next + '&newOrderNumber=' + vue.expressNumber)
            } else {
              // let type = response.data.type
              let message
              let expressNumber = response.data.expressNumber
              // if (type === 'FOR_MERCHANT_STORE') {
              //   message = 'MerchantStoreSuccess'
              // } else if (type === 'FOR_CUSTOMER_STORE') {
              //   message = 'CustomerStoreSuccess'
              // } else {
              //   message = 'Success'
              // }

              message = returnMessage.replace('{{orderId}}', expressNumber)

              vue.displaySuccessTip(message)

              vue.cleanInput()

              // vue.$router.push('/return/success?msg=' + message + '&action=' + vue.action + '&orderId=' + orderId + '&expressNumber=' + response.data.expressNumber + '&next=' + next)
            }
          }).catch(function (error) {
            if (error.data && error.data.message) {
              // vue.tipMsg = error.data.message
              // vue.displayTip(error.data.message)
              var errorMessage = error.data.message
              // if (errorMessage.includes('運號不存在，請重新掃碼或輸入！')) {
              //   errorMessage = 'Order not found, please check your tracking number.'
              // } else if (errorMessage.includes('此訂單早前已被成功提取')) {
              //   errorMessage = 'Order not found, please check your access code.'
              // } else if (errorMessage.includes('當前訂單的狀態不允許上架。')) {
              //   errorMessage = 'Order not able to be stored.'
              // }
              vue.displayTip(errorMessage)
            } else {
              vue.displayTip('error')
            }
          })
          break
          // 取件 - 扫码签出给客户
        case 'collectingPointTakeExpress':
          let queryNumber = this.$route.query.expressNumber
          if (queryNumber !== this.expressNumber) {
            vue.displayTip(this.$t('barCode.mismatch'))
            return false
          }

          vue.$router.push({path: '/return/identity', query: {action: 'collectingPointTakeExpress', expressNumber: queryNumber, pin: vue.pin}})

          // this.axios({
          //   method: 'post',
          //   url: this.api.collectingPointTakeExpress,
          //   data: {
          //     expressNumber: vue.expressNumber,
          //     pinCode: this.pin,
          //     type: 'FOR_CUSTOMER_TAKE'
          //   }
          // }).then(function (response) {
          //   // let ordersId = response.data.ordersId
          //   let message = 'CollectSuccess'
          //   vue.$router.push('/return/success?msg=' + message + '&action=collectingPointTakeExpress')
          // }).catch(function (error) {
          //   if (error.data.message) {
          //     vue.displayTip(error.data.message)
          //   } else {
          //     vue.displayTip(error)
          //   }
          // })
          break
          // 扫码 - 收用户退件
        case 'merchantTakeExpress':
          if (vue.queryNumber && (vue.queryNumber !== vue.expressNumber)) {
            vue.displayTip(this.$t('barCode.mismatch'))
            break
          }
          let id = this.$route.query.logisticsId
          this.axios({
            method: 'post',
            url: this.api.merchantTakeExpress,
            data: {
              type: 'FOR_CUSTOMER_STORE',
              expressNumber: vue.expressNumber,
              logisticsId: id
            }
          }).then(function (response) {
            vue.$router.push('/return/success?msg=ReturnSuccess' + '&action=merchantTakeExpress' + '&expressNumber=' + response.data.expressNumber + '&logisticsId=' + id + '&next=' + next)
          }).catch(function (error) {
            if (error.data.message) {
              vue.tipMsg = error.data.message
              vue.displayTip(error.data.message)
            }
          })
          break
          // 扫码 - 收逾期件 -给物流
        case 'collectExpiredExpress':
          const newLabelNumber = vue.$route.query.newLabelNumber
          if ((vue.queryNumber && (vue.queryNumber !== vue.expressNumber)) && newLabelNumber !== vue.expressNumber) {
            vue.displayTip(this.$t('barCode.mismatch'))
            break
          }
          // 先查出物流ID
          let logisticsId = this.$route.query.logisticsId
          this.axios({
            method: 'post',
            url: this.api.collectExpiredExpress,
            data: {
              expressNumber: vue.expressNumber,
              type: 'FOR_MERCHANT_STORE',
              logisticsId: logisticsId
            }
          }).then(function (response) {
            vue.$router.push('/return/success?msg=ReturnSuccess' + '&action=collectExpiredExpress' + '&logisticsId=' + logisticsId + '&expressNumber=' + response.data.expressNumber + '&next=' + next)
          }).catch(function (error) {
            if (error.data.message) {
              vue.tipMsg = error.data.message
              vue.displayTip(error.data.message)
            }
          })
          break
        default:
          vue.displayTip('unknow')
          break
      }
      return false
    },
    back () {
      this.$router.go(-1)
    },
    displayTip (msg = null) {
      let vue = this
      this.showTip = true
      this.tipMsg = msg
      setTimeout(function () {
        vue.showTip = false
        vue.tipMsg = null
      }, 2000)
    },
    displaySuccessTip (msg = null) {
      let vue = this
      this.showSuccessTip = true
      this.successTipMsg = msg
      setTimeout(function () {
        // 关闭提示
        vue.showSuccessTip = false
        vue.successTipMsg = null
      }, 3000)
    },
  }
}
</script>

<style lang="less" src="../../assets/css/return/entercode.css" scoped>
</style>
<style lang="less" scoped>
    .barcode_input {
        margin: 0 auto;
        margin-top: 0.225rem;
        background: #FFFFFF;
        width: 3.525rem;
        height: 0.745rem;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
        display: flex;
        position: relative;
        z-index: 1;

        .code_input {
            border: none;
            color: #707070;
            height: 0.385rem;
            line-height: 0.385rem;
            font-size: 0.35rem;
            font-weight: 900;
            width: 3.01rem;
            margin-top: 0.185rem;
            margin-left: 0.205rem;
        }

        .close {
            position: absolute;
            z-index: 1;
            right: 0.07rem;
            top: 0.27rem;
            width: 0.21rem;
            height: 0.21rem;
            background: #D6D6D6;
            border-radius: 50%;
        }

        .close:before, .close:after {
            position: absolute;
            left: 0.093rem;
            top: 0.032rem;
            content: ' ';
            height: 0.14rem;
            width: 2px;
            background-color: #FFFFFF;
        }

        .close:before {
            transform: rotate(45deg);
        }

        .close:after {
            transform: rotate(-45deg);
        }
    }

    .barcode_msg {
        width: 3.525rem;
        height: 0.965rem;
        margin: 0 auto;
        margin-top: 0.13rem;

        div {
            max-width: 0.94rem;
            font-size: 0.09rem;
            font-weight: 900;
            line-height: 0.125rem;
            background: #FFFFFF;
            color: #FF0000;
            border: 1px solid #707070;
            float: left;
            margin-left: 0.14rem;
            padding: 0.075rem 0.055rem;
        }

        .first {
            margin-left: 0;
        }
    }

    .curtain {
        z-index: 2;
        height: 100%;
        width: 100%;
        background: #0f0f0f;
        opacity: 50%;
        position: fixed;
        top: 0;
        left: 0;
    }

    .popup-msg {
        z-index: 3;
        position: fixed;
        width: 94%;
        left: 3%;
        top: 30%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
    }

    .popup-msg-text {
        margin-top: 0.2rem;
        text-align: center;
        padding-left: 10%;
        padding-right: 10%;
        font-size: 0.15rem;
        margin-bottom: 0.1rem;
    }

    .try-again {
        width: 82%;
        height: 0.58rem;
        background: linear-gradient(113deg, #052460 0%, #1f9dc5 100%);
        -webkit-box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        margin: 0.1rem 9% 0;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
        margin-bottom: 0.2rem;
    }

    // .tip-msg {
    //     z-index: 3;
    //     position: fixed;
    //     top: 0.1rem;
    //     width: 90%;
    //     margin-left: 2%;
    //     background: rgba(255, 0, 0, 0.4);
    //     border-radius: 0.05rem;
    //     color: #fff;
    //     font-weight: 400;
    //     padding: 0.1rem;
    //     font-size: 0.15rem;
    //     text-align: center;
    //     max-width: 400px;
    // }

    // /*vue 动画CSS*/
    // .tipMsg-enter-active, .tipMsg-leave-active {
    //     transition: opacity .5s;
    // }

    // .tipMsg-enter, .tipMsg-leave-to /* .fade-leave-active below version 2.1.8 */ {
    //     opacity: 0;
    // }
</style>



// WEBPACK FOOTER //
// src/components/Return/EnterBarcode.vue